import { Modal } from 'lego-on-react';
import * as React from 'react';

import { AddCampaignTypeMenuContainer } from '../../containers/AddCampaignTypeMenuContainer/AddCampaignTypeMenuContainer';
import { AddEntityMenuContainer } from '../../containers/AddEntityMenuContainer/AddEntityMenuContainer';
import { CampaignAndGroupSelectorContainer } from '../../containers/CampaignAndGroupSelectorContainer/CampaignAndGroupSelectorContainer';
import { PhrasesSelectorGridContainer } from '../../containers/PhrasesSelectorGridContainer/PhrasesSelectorGridContainer';
import { PhrasesSelectorInspectorOldContainer } from '../../containers/PhrasesSelectorInspectorOldContainer/PhrasesSelectorInspectorOldContainer';
import { SideInfoMenuContainter } from '../../containers/SideInfoMenuContainter/SideInfoMenuContainter';
import { Bem } from '../../service/Bem/Bem';
import { PhrasesSelectorWizardId } from '../../typings/phrases';
import { SecondLevelSidebarMenuIds, ThirdLevelSidebarMenuIds } from '../../typings/sidebar';

import './Sidebar.css';
import { SidebarLinksMenu, SidebarLinksMenuLink } from './SidebarLinksMenu/SidebarLinksMenu';
import { SidebarMenu, SidebarMenuItems } from './SidebarMenu/SidebarMenu';

export interface SidebarProps {
    expanded: boolean;
    items: SidebarMenuItems;
    secondLevelMenuId?: SecondLevelSidebarMenuIds;
    secondLevelLinks?: SidebarLinksMenuLink[];
    thirdLevelMenuId?: ThirdLevelSidebarMenuIds;
    onExpandClick: () => void;
    onParanjaClick: () => void;
    isCampaignAndGroupSelectorOpen: boolean;
    closeCampaignAndGroupSelectorHandler: () => void;
}

export class Sidebar extends React.Component<SidebarProps> {
    render() {
        const { expanded, onExpandClick, items, secondLevelMenuId, onParanjaClick } = this.props;
        const isInnerMenuVisible = secondLevelMenuId !== undefined;

        return (
            <div
                className={Bem.cls({
                    block: 'sidebar',
                    mods: { 'menu-expanded': isInnerMenuVisible }
                })}
            >
                <SidebarMenu
                    expanded={expanded}
                    onExpandClick={onExpandClick}
                    items={items}
                    secondLevelMenuContent={this.getSecondLevelMenuContent()}
                    thirdLevelMenuContent={this.getThirdLevelMenuContent()}
                />

                <div className={Bem.cls('sidebar', 'paranja')} onClick={onParanjaClick} />

                <PhrasesSelectorGridContainer isMinusPhrasesEnabled={true} wizardId={PhrasesSelectorWizardId.sideBar} />

                <PhrasesSelectorInspectorOldContainer
                    wizardId={PhrasesSelectorWizardId.sideBar}
                    isMinusWordsListEnabled={true}
                />

                {this.getModal()}
            </div>
        );
    }

    private getSecondLevelMenuContent(): React.ReactNode {
        const { secondLevelMenuId, secondLevelLinks } = this.props;

        switch (secondLevelMenuId) {
            case SecondLevelSidebarMenuIds.addEntity: {
                return <AddEntityMenuContainer />;
            }
            case SecondLevelSidebarMenuIds.reportsMenu:
            case SecondLevelSidebarMenuIds.libraryMenu: {
                if (secondLevelLinks) {
                    return <SidebarLinksMenu links={secondLevelLinks} />;
                } else {
                    return null;
                }
            }
            case SecondLevelSidebarMenuIds.infoMenu: {
                return <SideInfoMenuContainter links={secondLevelLinks} />;
            }
            default: {
                return null;
            }
        }
    }

    private getThirdLevelMenuContent(): React.ReactNode {
        const { thirdLevelMenuId } = this.props;

        if (thirdLevelMenuId === ThirdLevelSidebarMenuIds.addCampaign) {
            return <AddCampaignTypeMenuContainer />;
        }

        return null;
    }

    private getModal() {
        const { isCampaignAndGroupSelectorOpen, closeCampaignAndGroupSelectorHandler } = this.props;

        return (
            <Modal
                view="classic"
                theme="normal"
                visible={isCampaignAndGroupSelectorOpen}
                onOutsideClick={closeCampaignAndGroupSelectorHandler}
            >
                <CampaignAndGroupSelectorContainer onCancel={closeCampaignAndGroupSelectorHandler} />
            </Modal>
        );
    }
}
